import React, {JSX} from 'react';
import {SharedRichText} from "./SharedRichText";
import SharedImage, {iImage} from "./SharedImage";
import {STRAPI_ROOT, STRAPI_API} from "../services/strapi";
import SharedGallery, {iGalleryItem} from "./SharedGallery";
import qs from "qs";


interface iDynamicZone {
    content: any[]; // Using 'any' since JSON can have various structures
}

export const DynamicZone: React.FC<iDynamicZone> = (props: iDynamicZone) => {

    const outEls: React.JSX.Element[] = []

    for (let i = 0; i < props.content.length; i++) {
        const c = props.content[i];
        switch (c['__component']) {
            case 'shared.rich-text':
                outEls.push(<SharedRichText key={i} content={c.body}/>)
                break;
            case 'shared.media':
                outEls.push(<SharedImage
                    key={c['file']['documentId']}
                    imageUrl={`${STRAPI_ROOT}${c['file']['url']}`}
                    altText={`${c['file']['alternativeText']}`}
                    maxWidth="720px"
                    maxHeight="420px"
                />)
                break;
            // case 'shared.code':
            //     outEls.push(<SharedCode key={i} content={c['Code']} language={c['Language']}/>)
            //     break
            case 'shared.gallery':

                const imgs: iImage[] = []

                for (let j = 0; j < c['image'].length; j++) {

                    const img = c['image'][j]['file'];

                    if (!img){
                        continue;
                    }

                    if (!img['url']){
                        continue;
                    }

                    let newImg = {
                        imageUrl: `${STRAPI_ROOT}${img['url']}`,
                        altText: `${img['alternativeText']}`,
                        key: img['documentId'],

                    }

                    imgs.push(newImg);

                }

                const galleryItems: iGalleryItem[] = imgs.map((image, i) => (
                    {
                        key: image.key,
                        content: <div
                            key={image.key}
                            style={{
                                // flex: `0 0 ${imageWidthPercent}%`,
                                padding: '0 8px',
                                boxSizing: 'border-box'
                            }}
                        >
                            <img
                                src={image.imageUrl}
                                alt={image.altText}
                                className="img-fluid rounded"
                                style={{
                                    width: '100%',
                                    height: '300px',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                    }
                ));


                outEls.push(<SharedGallery
                    items={galleryItems}
                    maxVisibleCount={3}
                    itemHeight="300px"
                    key={`gallery-${i}`}
                />)

                break
            default:
                console.log(c['__component']);
                console.log('default - unknown component');
            // break
        }
    }

    // console.log(outEls);

    return <div>
        {outEls}
    </div>
}

export default DynamicZone;



